import { orderBy } from "lodash";
import { MemberContractManageModel } from "src/api/contract/contract-types";
import { Sort } from "src/api/public-types";

export type InviteResult = {
  type: "SUCCESS" | "FAIL";
  phoneNumber?: string;
  email?: string;
  failErrorCode?: string;
};

/**
 * 계약의 이용자 정렬 기준. 계약자 > 이용자 마스터 > 이용자 순, 같은 등급 안에서는 최근 초대순.
 * 목록 화면과 일괄 삭제 엑셀 양식이 같은 순서로 보여야 해서 한 곳에 둔다 (QA-3731).
 * 정렬을 안 보내면 DB 테이블 기본 순서(unsorted)로 내려온다
 */
export const MEMBER_SORT: Sort = {
  orders: [
    { direction: "DESC", property: "isContractor" }, // 계약자
    { direction: "DESC", property: "isAdmin" }, // 이용자 마스터
    { direction: "DESC", property: "contractMemberId" }, // 초대 시점에 증가하는 id 라 최근 초대순이 된다
  ],
};

/** 클라이언트 sorting 로직 */
export const sortMembers = (members: MemberContractManageModel[]) => {
  return orderBy(
    members,
    [(member) => !!member.isContractor, (member) => !!member.isAdmin, (member) => member.contractMemberId ?? 0],
    ["desc", "desc", "desc"],
  );
};
